import { render, staticRenderFns } from "./woTemplate.vue?vue&type=template&id=4d8ec37b&"
import script from "./woTemplate.vue?vue&type=script&lang=js&"
export * from "./woTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports